import React from 'react';

import { InputDefault as NewInput } from './InputDefault/InputDefault';

const InputDefault = ({ ...rest }) => <NewInput {...rest} />;

export default InputDefault;
